import React from 'react';

const Footer = ({ setActiveTab }) => {
    return (
        <footer className="footer">
            <div className="container">
                <div className="footer-grid">
                    <div className="footer-section">
                        <h3>Фреш 169</h3>
                        <p>Более 7-ми лет на автомобильном рынке.</p>
                    </div>
                    <div className="footer-section">
                        <h3>Навигация</h3>
                        <ul className="footer-nav">
                            <li><button onClick={() => setActiveTab('home')}>Главная</button></li>
                            <li><button onClick={() => setActiveTab('catalog')}>Каталог</button></li>
                            <li><button onClick={() => setActiveTab('services')}>Услуги</button></li>
                            <li><button onClick={() => setActiveTab('about')}>О нас</button></li>
                        </ul>
                    </div>
                    <div className="footer-section">
                        <h3>Контакты</h3>
                        <ul className="contact-list">
                            <li></li>
                            <li>Email: contact.ooo.fresh169@gmail.com</li>
                            <li>170518, Тверская область, Калининский р-н, д 
Кривцово, д. 81/1, этаж 2 кабинет 1  </li>
                        </ul>
                    </div>
                    <div className="footer-section">
                        <h3>Связь с Консультантом</h3>
                        <div className="social-icons">
                            <a
                                href="https://t.me/YuraavtoEU"
                                className="social-icon"
                                target="_blank"
                                rel="noopener noreferrer"
                            >TG</a>
                            <a
                                href="https://t.me/Igor_Kul4884"
                                className="social-icon"
                                target="_blank"
                                rel="noopener noreferrer"
                            >TG</a>
                        </div>
                    </div>
                </div>
                <div className="copyright">
                    <p>© 2025 Фреш 169. Все права защищены.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;